module.exports = __webpack_public_path__ + "static/media/ari.11eeb042.png";